const cards = [
  {
    title: '咒术回战',
    subtitle: '芥见下下 · 热血/黑暗奇幻',
    desc: '高中生虎杖悠仁吞下诅咒之王宿傩的手指，从此踏入咒术师的世界。咒灵、咒术、生死之战，一部颠覆传统热血漫画的黑暗奇幻巨作。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20anime%20character%20illustration%2C%20Japanese%20manga%20style%2C%20warm%20crimson%20and%20charcoal%20tones%2C%20mysterious%20atmosphere%2C%20dynamic%20pose%2C%20professional%20comic%20art%2C%20clean%20background&width=600&height=800&seq=card-manga-01&orientation=portrait',
    alt: '咒术回战 漫画封面',
    tag: '人气TOP1',
  },
  {
    title: '海贼王',
    subtitle: '尾田荣一郎 · 冒险/热血',
    desc: '路飞与草帽一伙的伟大航路冒险仍在继续，ONE PIECE的真相即将揭晓。连载超过25年的不朽传奇，漫画史上销量第一的王者之作。',
    img: 'https://readdy.ai/api/search-image?query=Adventure%20anime%20pirate%20character%20illustration%2C%20Japanese%20manga%20style%2C%20warm%20golden%20and%20ocean%20tones%2C%20heroic%20atmosphere%2C%20dynamic%20action%20pose%2C%20professional%20comic%20art&width=600&height=800&seq=card-manga-02&orientation=portrait',
    alt: '海贼王 漫画封面',
    tag: '经典神作',
  },
  {
    title: '间谍过家家',
    subtitle: '远藤达哉 · 喜剧/日常',
    desc: '间谍父亲、杀手母亲、读心女儿——三个各怀秘密的人组成伪装家庭，却在相处中找到了真正的亲情。温馨搞笑又治愈的家庭喜剧。',
    img: 'https://readdy.ai/api/search-image?query=Family%20comedy%20anime%20illustration%2C%20Japanese%20manga%20style%2C%20warm%20peach%20and%20cream%20tones%2C%20playful%20atmosphere%2C%20cute%20character%20design%2C%20professional%20comic%20art&width=600&height=800&seq=card-manga-03&orientation=portrait',
    alt: '间谍过家家 漫画封面',
    tag: '治愈必看',
  },
  {
    title: '葬送的芙莉莲',
    subtitle: '山田钟人/阿部司 · 奇幻/治愈',
    desc: '勇者一行人打败魔王后，精灵魔法使芙莉莲独自踏上理解人类的旅程。一部关于时间、生命与羁绊的奇幻诗篇，温暖而深刻。',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20melancholic%20anime%20illustration%2C%20Japanese%20manga%20style%2C%20warm%20amber%20and%20soft%20green%20tones%2C%20nostalgic%20atmosphere%2C%20elegant%20character%2C%20professional%20comic%20art&width=600&height=800&seq=card-manga-04&orientation=portrait',
    alt: '葬送的芙莉莲 漫画封面',
    tag: '口碑佳作',
  },
  {
    title: '坂本日常',
    subtitle: '铃木祐斗 · 动作/喜剧',
    desc: '昔日最强杀手坂本太郎结婚后发福成为便利店老板，但危险从未远离。超乎想象的战斗场面和反差萌日常，JUMP新世代王牌。',
    img: 'https://readdy.ai/api/search-image?query=Action%20comedy%20anime%20illustration%2C%20Japanese%20manga%20style%2C%20warm%20terracotta%20and%20cream%20tones%2C%20dynamic%20fight%20scene%2C%20cool%20character%2C%20professional%20comic%20art&width=600&height=800&seq=card-manga-05&orientation=portrait',
    alt: '坂本日常 漫画封面',
    tag: 'JUMP新星',
  },
  {
    title: '怪兽8号',
    subtitle: '松本直也 · 科幻/热血',
    desc: '32岁清洁工日比野卡夫卡意外获得变身怪兽的能力，以"怪兽8号"身份加入防卫队。中年人的英雄梦，燃到飙泪的科幻战斗漫画。',
    img: 'https://readdy.ai/api/search-image?query=Sci-fi%20monster%20anime%20illustration%2C%20Japanese%20manga%20style%2C%20warm%20coral%20and%20steel%20tones%2C%20epic%20battle%20atmosphere%2C%20dynamic%20monster%20design%2C%20professional%20comic%20art&width=600&height=800&seq=card-manga-06&orientation=portrait',
    alt: '怪兽8号 漫画封面',
    tag: '燃爆推荐',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2 text-center">
          热门推荐
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">精选不可错过的必读漫画</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:ring-2 hover:ring-primary-200 flex flex-col sm:flex-row lg:flex-col">
              <div className="sm:w-2/5 lg:w-full aspect-[3/4] sm:aspect-auto lg:aspect-[3/4] overflow-hidden flex-shrink-0">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 p-4 flex flex-col">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <h3 className="font-heading font-bold text-base text-foreground-900">{item.title}</h3>
                  <span className="px-2 py-0.5 rounded bg-primary-100 text-primary-700 text-[10px] font-semibold whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-foreground-400 text-xs mb-2">{item.subtitle}</p>
                <p className="text-foreground-500 text-xs leading-relaxed flex-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}